var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandComment24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.524 13.76a.755.755 0 0 1 .985-.063.582.582 0 0 1 .07.882l-4.06 4.205a.736.736 0 0 1-.53.216.734.734 0 0 1-.527-.218L7.42 14.578a.583.583 0 0 1 .074-.883.756.756 0 0 1 .984.066l3.514 3.655 3.533-3.657ZM11.99 5a.74.74 0 0 1 .53.216l4.06 4.205a.582.582 0 0 1-.07.882.755.755 0 0 1-.985-.062l-3.533-3.658-3.514 3.656a.756.756 0 0 1-.985.066.583.583 0 0 1-.073-.883l4.043-4.204.052-.05A.744.744 0 0 1 11.989 5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandComment24);
export default __webpack_public_path__ + "static/media/expand_comment_24.2cd96db72037a0085e340bc4ff2de482.svg";
export { ForwardRef as ReactComponent };